import WebFont from 'webfontloader';

export const loadFont = () => {
    WebFont.load({
        google: {
          families: ['Roboto', 'sans-serif']
        }
      });
}



// WEBPACK FOOTER //
// ./src/font/loadFonts.js